export const resolvePanelizedItemCntName = (value: number) => (value === 1 ? "なし" : `${value}面付`)
export const resolvePanelizedItemKindCntName = (value: number) => (value === 1 ? "同種" : `${value}種`)
export const resolveRouterCutKindName = (value: number) => `${value}種`
export const resolveRouletteKindName = (value: number) => `${value}種`
